export default "__VITE_PUBLIC_ASSET__3a6daa4a__"